(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["desktop-search-bar"] && !Shopify.designMode) return;
  try {
    class DesktopPredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
      this.cachedResults = {};
      this.backdrop = null;
      this.boundDocClick = this.handleDocClick.bind(this);

      this.input.addEventListener(
        'input',
        this.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );

      this.resetBtn = this.querySelector('.desktop-search-bar__reset');
      if (this.resetBtn) {
        this.toggleResetButton();
        this.input.addEventListener('input', () => this.toggleResetButton());
        this.input.form.addEventListener('reset', () => setTimeout(() => this.toggleResetButton(), 0));
      }
      this.input.addEventListener('focus', this.onFocus.bind(this));
      this.input.addEventListener('blur', this.onInputBlur.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.addEventListener('keyup', this.onKeyup.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
    }

    toggleResetButton() {
      if (!this.resetBtn) return;
      const hasText = this.input.value.trim().length > 0;
      this.resetBtn.classList.toggle('hidden', !hasText);
    }

    handleDocClick(e) {
      if (this.getAttribute('open') !== 'true') return;
      if (this.contains(e.target)) return;
      if (this.backdrop && this.backdrop.contains(e.target)) return;
      this.close();
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    onChange() {
      const searchTerm = this.input.value.trim();

      if (!searchTerm.length) {
        this.close();
        return;
      }

      this.getSearchResults(searchTerm);
    }

    onFocus() {
      const searchTerm = this.input.value.trim();
      if (!searchTerm.length) return;
      this.getSearchResults(searchTerm);
    }

    onInputBlur(event) {
      if (event.relatedTarget && this.contains(event.relatedTarget)) return;
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      }, 200);
    }

    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      }, 200);
    }

    onKeyup(event) {
      if (event.code.toUpperCase() === 'ESCAPE') this.close();
    }

    onKeydown(event) {
      if (event.code.toUpperCase() === 'ARROWUP' || event.code.toUpperCase() === 'ARROWDOWN') {
        event.preventDefault();
      }
    }

    getSearchResults(searchTerm) {
      const queryKey = searchTerm.replace(' ', '-').toLowerCase();

      if (this.cachedResults[queryKey]) {
        this.renderSearchResults(this.cachedResults[queryKey]);
        return;
      }

      fetch(
        `${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(
          searchTerm
        )}&resources[type]=product,query,collection` +
          `&resources[limit]=6&resources[limit_scope]=each` +
          `&section_id=predictive-search`
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then((text) => {
          const section = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search');
          if (!section || !section.innerHTML) {
            this.close();
            return;
          }

          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = section.innerHTML;

          const loadingStates = tempDiv.querySelectorAll(
            '.predictive-search__loading-state, .spinner, [class*="loading"]'
          );
          loadingStates.forEach((el) => el.remove());

          this.cachedResults[queryKey] = tempDiv.innerHTML;

          this.renderSearchResults(tempDiv.innerHTML);
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }

    setLiveRegionText(statusText) {
      this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
      this.statusElement.setAttribute('aria-hidden', 'false');
      this.statusElement.textContent = statusText;

      setTimeout(() => {
        this.statusElement.setAttribute('aria-hidden', 'true');
      }, 1000);
    }

    renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = '';

      if (!resultsMarkup || !resultsMarkup.trim()) {
        this.close();
        return;
      }

      const resultsContainer = document.createElement('div');
      resultsContainer.innerHTML = resultsMarkup;

      this.predictiveSearchResults.appendChild(resultsContainer);

      const loadingState = this.predictiveSearchResults.querySelector('.predictive-search__loading-state');
      if (loadingState) {
        loadingState.remove();
      }

      const hasResults = this.predictiveSearchResults.querySelector(
        '.predictive-search__list-item, .predictive-search__item, [id^="predictive-search-option-"]'
      );
      if (!hasResults) {
        this.close();
        return;
      }

      this.setAttribute('results', true);

      const resultsCount = this.predictiveSearchResults.querySelector(
        '[data-predictive-search-live-region-count-value]'
      );
      if (resultsCount) {
        this.setLiveRegionText(resultsCount.textContent);
      }

      this.open();
    }

    getResultsMaxHeight() {
      return window.innerHeight - this.getBoundingClientRect().bottom - 20;
    }

    open() {
      this.setAttribute('open', true);
      this.input.setAttribute('aria-expanded', true);
      const maxH = this.getResultsMaxHeight();
      if (this.predictiveSearchResults) this.predictiveSearchResults.style.maxHeight = `${maxH}px`;
      this.addBackdrop();
      document.addEventListener('mousedown', this.boundDocClick, true);
      document.addEventListener('click', this.boundDocClick, true);
      const bar = this.closest('.desktop-search-bar');
      if (bar) bar.classList.add('desktop-search-dropdown-open');
    }

    addBackdrop() {
      if (this.backdrop) return;
      this.backdrop = document.createElement('div');
      this.backdrop.className = 'desktop-search-backdrop';
      this.backdrop.setAttribute('aria-hidden', 'true');
      this.backdrop.addEventListener('mousedown', (e) => { e.preventDefault(); e.stopPropagation(); this.close(); });
      this.backdrop.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.close(); });
      var root = document.body;
      if (!root) root = document.documentElement;
      root.appendChild(this.backdrop);
    }

    removeBackdrop() {
      if (this.backdrop && this.backdrop.parentNode) {
        this.backdrop.parentNode.removeChild(this.backdrop);
        this.backdrop = null;
      }
      document.removeEventListener('mousedown', this.boundDocClick, true);
      document.removeEventListener('click', this.boundDocClick, true);
      const bar = this.closest('.desktop-search-bar');
      if (bar) bar.classList.remove('desktop-search-dropdown-open');
    }

    close() {
      this.setAttribute('open', false);
      this.input.setAttribute('aria-expanded', false);
      this.predictiveSearchResults.removeAttribute('style');
      this.removeAttribute('results');
      this.removeBackdrop();
    }
  }

  if (!customElements.get('desktop-predictive-search')) {
    customElements.define('desktop-predictive-search', DesktopPredictiveSearch);
  }

  document.querySelectorAll('.desktop-search-bar search-form').forEach(function (wrapper) {
    var form = wrapper.querySelector('form');
    var input = form && form.querySelector('input[type="search"]');
    var resetBtn = form && form.querySelector('.desktop-search-bar__reset');
    if (!input || !resetBtn) return;
    function toggle() {
      resetBtn.classList.toggle('hidden', !input.value.trim().length);
    }
    toggle();
    input.addEventListener('input', toggle);
    form.addEventListener('reset', function () { setTimeout(toggle, 0); });
  });
  } catch(e) { console.error(e); }
})();

})();
